import {
    GET_BANKER_RECOMMENDED_RESULTS,
    GET_BANKER_RECOMMENDED_RESULTS_SUCCESS,
    GET_BANKER_RECOMMENDED_RESULTS_FAILURE,
    SET_PRODUCT_FILTER_LIST,
    SET_BANKER_RECOMMENDEDN_RESULTS_FILTER,
    GET_ALL_BANKER_PRODUCTS,
    GET_ALL_BANKER_PRODUCTS_SUCCESS,
    GET_ALL_BANKER_PRODUCTS_FAILURE,
} from '../../constants';
import {
    dynamicClient as graphQlClient,
    PULL_BANKER_PRODUCT_RECOMMENDATIONS,
    GET_ALL_BANKER_PRODUCTS as GET_ALL_BANKER_PRODUCTS_QUERY,
} from '../../graphql';
import { productOrdering } from '../../utils/dynamicDpsUtils';

export const getAllBankerProductsSuccess = (allProducts) => ({
    type: GET_ALL_BANKER_PRODUCTS_SUCCESS,
    allProducts,
    error: null,
    isLoading: false,
});

export const getAllBankerProductsFailure = (error) => ({
    type: GET_ALL_BANKER_PRODUCTS_FAILURE,
    error,
    isLoading: false,
});

export const getBankerRecommendedResultsSuccess = (
    recommendedResults,
) => ({
    type: GET_BANKER_RECOMMENDED_RESULTS_SUCCESS,
    recommendedResults: productOrdering(recommendedResults),
    error: null,
    isLoading: false,
});

export const getBankerRecommendedResultsFailure = (error) => ({
    type: GET_BANKER_RECOMMENDED_RESULTS_FAILURE,
    error,
    isLoading: false,
});

export const setProductFilterList = (productList) => ({
    type: SET_PRODUCT_FILTER_LIST,
    filterList: productList,
});

export const updateFilteredResults = (filteredResults) => ({
    type: SET_BANKER_RECOMMENDEDN_RESULTS_FILTER,
    filteredResults,
    isLoading: false,
});

export const getBankerRecommendedResults =
    (payload) => async (dispatch) => {
        try {
            dispatch({
                type: GET_BANKER_RECOMMENDED_RESULTS,
                isLoading: true,
            });
            const {
                productID,
                sessionID,
                customerID,
                selectedQuestionnaire,
            } = payload;
            await graphQlClient
                .mutate({
                    mutation: PULL_BANKER_PRODUCT_RECOMMENDATIONS,
                    variables: {
                        productID,
                        sessionID,
                        customerID,
                        selectedQuestionnaire,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((data) => {
                    const {
                        data: {
                            pullProductRecommendations: {
                                recommendedProducts:
                                    recommendedResults,
                            },
                        },
                    } = data;

                    dispatch(
                        getBankerRecommendedResultsSuccess(
                            recommendedResults,
                        ),
                    );
                });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
            dispatch(getBankerRecommendedResultsFailure(err));
        }
    };
export const getAllBankerProducts = (payload) => async (dispatch) => {
    try {
        dispatch({
            type: GET_ALL_BANKER_PRODUCTS,
            isLoading: true,
        });
        const { productID, sessionID } = payload;

        await graphQlClient
            .query({
                query: GET_ALL_BANKER_PRODUCTS_QUERY,
                variables: {
                    productID,
                    sessionID,
                    customerID: sessionID,
                },
                fetchPolicy: 'no-cache',
            })
            .then((data) => {
                const {
                    data: {
                        getAllAvailableProducts: {
                            recommendedProducts: allProducts,
                        },
                    },
                } = data;

                dispatch(getAllBankerProductsSuccess(allProducts));
            });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        dispatch(getAllBankerProductsFailure(err));
    }
};
